import axios from '@/axiosInterceptor';

const state = () => ({
  activity: {},
  activityTypes: [],
});

const actions = {
  async getActivityTypes({ commit }) {
    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/user_activities/types`
      );
      commit('setActivityTypes', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async postActivity({ commit }, { user_activity }) {
    const body = {
      user_activity,
    };

    try {
      let res = await axios.post(
        `${process.env.API_IDENTITY}/api/v1/user_activities`,
        body
      );

      commit('setActivity', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setActivityTypes(state, data) {
    state.activityTypes = data;
  },
  setActivity(state, data) {
    state.activity = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
